import { searchCards, getCardDetails, moveCard } from '../ProjectBoardServices/BoardModalAPI/BoardDetailsPageAPI/BoardDeatils';

export const findContainer = (columns, taskId) => {
  if (!taskId || !columns) return null;
  if (columns.some(col => col.id === taskId)) return taskId;
  for (const col of columns) {
    if (col.tasks?.some(task => task.id === taskId)) {
      return col.id;
    }
  }
  return null;
};

export const fetchListsAndCards = async (boardId, filters = {}) => {
  try {
    if (!boardId) throw new Error('Board ID is required');

    // ✅ Service function use kar rahe hain
    const res = await searchCards(boardId, filters);

    const data = Array.isArray(res.data?.data) ? res.data.data : [];

    const columnsWithCards = data.map(col => ({
      ...col,
      tasks: (col.cards || []).map(card => ({
        ...card,
        id: card.id || card._id || card.cardId || card.taskId || `card_${Date.now()}_${Math.random()}`,
        listId: col.id,
        originalId: card.id,
        _id: card._id,
        cardId: card.cardId,
      })),
    }));

    return { columnsWithCards, error: null };
  } catch (err) {
    console.error('Error fetching lists and cards:', err);
    return { columnsWithCards: [], error: err.message || 'Failed to load columns or cards.' };
  }
};

export const fetchCardDetails = async (cardId) => {
  try {
    // ✅ Service function use kar rahe hain
    const response = await getCardDetails(cardId);
    return response.data?.data || null;
  } catch (error) {
    console.error('Error fetching card details:', error);
    return null;
  }
};

export const moveCardAPI = async (cardId, newListId, newPosition) => {
  try {
    // ✅ Service function use kar rahe hain
    const response = await moveCard(cardId, newListId, newPosition);
    return response.data;
  } catch (error) {
    console.error('Error moving card:', error);
    throw error;
  }
};

export const handleDragEndLogic = async (
  event,
  columnsRef,
  setColumns,
  moveCardAPI,
  toast
) => {
  const { active, over } = event;

  if (!over) return;

  const task = event.active.data.current?.task;
  if (!task) return;

  const activeId = active.id;
  const overId = over.id;

  const activeContainer = findContainer(columnsRef.current, activeId);
  const overContainer = findContainer(columnsRef.current, overId) || overId;

  const cardId = task.originalId || task._id || task.cardId || task.id;
  if (!cardId) return;

  // Store original state for rollback
  const originalColumns = [...columnsRef.current];

  try {
    if (activeContainer !== overContainer) {
      // Moving to a different column
      setColumns(prev => {
        const sourceIdx = prev.findIndex(col => col.id === activeContainer);
        const destIdx = prev.findIndex(col => col.id === overContainer);
        if (sourceIdx === -1 || destIdx === -1) return prev;

        const sourceCol = prev[sourceIdx];
        const destCol = prev[destIdx];

        const taskIndex = sourceCol.tasks.findIndex(t => t.id === activeId);
        const task = sourceCol.tasks[taskIndex];
        const updatedTask = { ...task, listId: overContainer };

        const newSourceTasks = [...sourceCol.tasks];
        newSourceTasks.splice(taskIndex, 1);

        const newDestTasks = [...destCol.tasks];
        if (overId === overContainer) {
          newDestTasks.push(updatedTask);
        } else {
          const overTaskIdx = destCol.tasks.findIndex(t => t.id === overId);
          if (overTaskIdx !== -1) {
            newDestTasks.splice(overTaskIdx, 0, updatedTask);
          } else {
            newDestTasks.push(updatedTask);
          }
        }

        const newCols = [...prev];
        newCols[sourceIdx] = { ...sourceCol, tasks: newSourceTasks };
        newCols[destIdx] = { ...destCol, tasks: newDestTasks };

        return newCols;
      });

      // Get the destination column from columnsRef
      const destCol = columnsRef.current.find(col => col.id === overContainer);
      if (!destCol) return;

      // Calculate new position
      let newPosition;
      if (overId === overContainer) {
        newPosition = destCol.tasks.length + 1;
      } else {
        const overTaskIdx = destCol.tasks.findIndex(t => t.id === overId);
        if (overTaskIdx !== -1) {
          newPosition = overTaskIdx + 1;
        } else {
          newPosition = destCol.tasks.length + 1;
        }
      }

      await moveCardAPI(cardId, overContainer, newPosition);
    } else {
      // Reordering within the same column
      const { arrayMove } = await import('@dnd-kit/sortable');
      const col = columnsRef.current.find(c => c.id === activeContainer);
      if (!col) return;

      const tasks = col.tasks;
      const activeIndex = tasks.findIndex(t => t.id === activeId);
      const overIndex = tasks.findIndex(t => t.id === overId);

      if (activeIndex === -1 || overIndex === -1 || activeIndex === overIndex) return;

      const newTasks = arrayMove(tasks, activeIndex, overIndex);

      setColumns(prev => {
        return prev.map(c => {
          if (c.id === activeContainer) {
            return { ...c, tasks: newTasks };
          }
          return c;
        });
      });

      const newPosition = overIndex + 1;
      await moveCardAPI(cardId, activeContainer, newPosition);
    }
  } catch (error) {
    // Rollback to original state
    setColumns(originalColumns);
    
    // Handle specific error cases
    let errorMessage = 'Failed to move card. Try again.';
    let errorTitle = 'Move Failed';

    if (error.response?.data) {
      const errorData = error.response.data;
      
      if (errorData.error && errorData.error.field === 'workflow') {
        errorTitle = 'Workflow Error';
        errorMessage = errorData.error.message || 'Transition not allowed';
      } else if (errorData.message) {
        errorMessage = errorData.message;
      } else if (errorData.field === 'workflow') {
        errorTitle = 'Workflow Error';
        errorMessage = errorData.message || 'Transition not allowed';
      }
    }

    toast({
      title: errorTitle,
      description: errorMessage,
      status: 'error',
      duration: 4000,
      isClosable: true,
    });

    console.error('Card move error:', error.response?.data || error);
  }
};
